import { defineComponent as _defineComponent } from 'vue'
import {numeralFormat} from '@/filters/StringFilters';
import {computed} from 'vue';
import {Schedule, ScheduleCostType, SummaryCost} from '@/components/calculator/schedule/Schedule';
import {useInstance} from '@/composables/useInstance';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {Utils} from '@/services/utils/BasicUtils';
import {sum} from 'lodash-es';

type TableHeaderValueType = 'title' | 'fee' | 'total';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleAdditionalCostsTable',
  setup(__props) {

const {keys,} = Utils;
const scheduleStore = useScheduleStore();
const {$i18n, $env,} = useInstance();

const tableHeaders: {text: string | null, value: TableHeaderValueType,}[] = [
  {text: null, value: 'title',},
  {text: $i18n.useScheduleModal.TABLE_HEADER_PAYMENT, value: 'fee',},
  {text: $i18n.useScheduleModal.TABLE_HEADER_SUM, value: 'total',},
];

const schedule = computed<Schedule | null>(() => scheduleStore.schedule);

const tableItems = computed<{name: string, fee: string, total: string}[]>(() => {
  const getKeyByValue = (value: string): keys<ScheduleCostType> => {
    return Object.keys(ScheduleCostType).find((key) => ScheduleCostType[key] === value) as keys<ScheduleCostType>;
  }
  return schedule.value?.summaryCosts?.length ? schedule.value.summaryCosts.map((x: SummaryCost) => {
    const nameKey = getKeyByValue(x.name);
    const name = $i18n.useScheduleModal[nameKey!] ?? 'No key';
    const fee: string = x.costs.map((cost) => `${numeralFormat(cost.fee)} ${$env.currentCurrency()}<br> <span class=" body-3">${cost.description}</span> <br>`).toString().replace(',', '');
    return {
      name,
      fee,
      total: `${numeralFormat(x.total)} ${$env.currentCurrency()}`,
    };
  }) : [];
})

const additionalCostsSum = computed<number>(() => {
  return schedule?.value?.summaryCosts?.length ? sum(schedule.value.summaryCosts.map(cost => cost.total)) : 0;
});

return { __sfc: true,keys, scheduleStore, $i18n, $env, tableHeaders, schedule, tableItems, additionalCostsSum }
}

})